import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import React, { useState } from 'react';

export const LibrarySelection = () => {
  const librarySelectItems = [
    { label: 'New York York York', value: 'NY' },
    { label: 'Rome', value: 'RM' },
    { label: 'London', value: 'LDN' },
    { label: 'Istanbul', value: 'IST' },
    { label: 'Paris', value: 'PRS' },
  ];

  const [selectedLibrary, setSelectedLibrary] = useState(null);

  const filterTemplate = () => {
    return <Button label="Neue Ablage" style={{ width: '100% ' }} />;
  };

  return (
    <>
      <div className="p-inputgroup" style={{ width: 'unset' }}>
        <Dropdown
          filter
          filterTemplate={filterTemplate}
          value={selectedLibrary}
          options={librarySelectItems}
          onChange={e => setSelectedLibrary(e.value)}
          placeholder="Select a library"
        />
        <Button icon="pi pi-bars" className="p-button-secondary" />
      </div>
    </>
  );
};
